import { useMemo } from 'react'
import { usePageInfo } from 'app/frontend/base/config/queries'
import {
  GameVersionCapability,
  gameVersionConfig,
  gameVersionHas,
} from 'app/frontend/types/custom/GameVersion'

export const useGameVersion = () => {
  const {
    data: { gameVersion },
  } = usePageInfo()

  return useMemo(
    () => ({
      id: gameVersion,
      has: (capability: GameVersionCapability) =>
        gameVersionHas(capability, gameVersion),
      config: gameVersionConfig(gameVersion),
    }),
    [gameVersion],
  )
}
